<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-truck"></i></span>{{ 'FreightSearch.Search.Title' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'FreightSearch.Search.Facility' | translate }}</label>
              <laas-facility-dropdown
                formControlName="facilityList"
                [isMultiple]="true"
                [showFilter]="true"
                [showToggleAll]="true">
              </laas-facility-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'FreightSearch.Search.ShipCorp' | translate }}</label>
              <p-multiSelect
                formControlName="shipCorpList"
                [options]="shipCorpOptions"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'FreightSearch.Search.ExpressBill' | translate }}</label>
              <p-chips formControlName="expressBillList" separator="," (onAdd)="chipsAdd($event, 'expressBillList')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'FreightSearch.Search.Brand' | translate }}</label>
              <laas-multiSelect
                formControlName="brandList"
                [options]="brandOptions"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </laas-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'FreightSearch.Search.Vendor' | translate }}</label>
              <laas-multiSelect
                formControlName="vendorOrConsigneeList"
                [options]="vendorOrConsigneeOptions"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [virtualScroll]="true"
                [virtualScrollItemSize]="50"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </laas-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'FreightSearch.Search.AdNoDoNo' | translate }}</label>
              <p-chips formControlName="adNoDoNoList" separator="," (onAdd)="chipsAdd($event, 'adNoDoNoList')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 laas-calendar">
              <laas-calendar
                #createDt
                [title]="'FreightSearch.Search.BillingCreateDt'"
                [requiredStar]="true"
                [defaultDate]="defaultCreateDt"
                [showRangeMode]="true"
                (onDateChange)="dateOnChange($event, 'createDt')">
              </laas-calendar>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchClickBtn()"></button>
              <button pButton pRipple label="{{ 'Common.Button.Export' | translate }}" (click)="exportClickBtn($event)" class="ml-2"></button>
              <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetClickBtn()" class="p-button-secondary ml-2"></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <div class="mt-2">
      <laas-data-table
        #dataTable
        [tableKey]="preferenceKey"
        [value]="searchResults"
        [defaultColumns]="tableColumns"
        [loading]="isLoading"
        [lazy]="true"
        [rows]="pageInfo.pageSize"
        [totalRecords]="pageInfo.totalRecords"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)">
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container>
                <ng-container *ngSwitchCase="'shipCorp'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: shipCorpOptions | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'freightChargeAmount'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'fuelSurchargeAmount'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'securitySurchargeAmount'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'otherChargeAmount'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'createDt'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date: 'yyyy/MM/dd HH:mm:ss' | replaceNullWith: '-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-'}}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
